export default {
    ENV: 'STAGE',
    API_BASE_PATH: '/api',
    APP_DOMAIN: 'https://engage.stage.macs.capgemini.com',
    PROD_IMAGE_API: 'https://engage.edge.capgemini.com/api/image/',
    STAGE_IMAGE_API: 'https://engage.stage.macs.capgemini.com/api/image/',
    IMAGE_API: '/api/image/',
    BASE_PATH: 'web',
    COUNTRY_ID_TYPE: 'c228140d9713d688cccc3d1846fcb1ee',
    MODULES: {
        IDEA_BOARD: 'IDEABOARD',
        NEWS: 'NEWSFORYOU',
        MEET_YOUR_TEAM: 'MEETYOURTEAM',
        CONTACT_US: 'CONTACTUS',
        SETTING_COMPANY_CONTENT: 'SETTINGCOMPANYCONTENT',
        SOLUTIONS: 'SOLUTIONSFORYOU',
        AGENDA: 'AGENDA'
    },
    SETTING_TYPES: {
       HOME_TITLE: 'HOMETITLE',
       IDEA_BOARD_CATEGORIES: 'POSTCATEGORIES',
       CLIENT_CATEGORIES: 'CLIENTCATEGORIES',
       SECTORS: 'SECTORS',
       CONTACT_US_EMAILS: 'CONTACTUSDEFAULT',
       HOME_ICONS: 'CUSTOMSECTIONICONS',
       AGENDA_TYPE: 'AGENDATYPE',
       PROJECTS_DOMAINS: 'PROJECTSDOMAINS',
       GDN_REGIONS: 'GDNREGIONS',
       GDN_COUNTRIES: 'GDNCOUNTRIES',
       GDN_UNITS: 'GDNUNITS',
       GDN_SECTION_PARAGRAPHS: 'GDNSECTIONPARAGRAPHS',
       GDN_SECTION_TABS: 'GDNSECTIONTABS',
       GDN_SUB_SECTIONS: 'GDNSUBSECTIONS',
       AGREEMENT_NEEDED: 'AGREEMENTNEEDED',
       USE_CUSTOM_OVERVIEW_MAP_TITLE: 'USECUSTOMOVERVIEWMAPTITLE',
       OVERVIEW: 'OVERVIEW',
       MAP_DATA: 'MAPDATA',
       KEY_FACTS: 'KEYFACTS',
       TIMELINE_DATA: 'TIMELINEDATA',
       SOLUTIONS_CONTENT_TYPES: 'SOLUTIONSCONTENTTYPES',
       START_DATE_NO_TREAD_CONTENT: 'STARTDATENOTREADCONTENT',
       TEAM_MEMBER_ROLES: 'TEAMMEMBERROLES'
    },
    SETTING_TYPES_FLAGS: {
        HIDE_CONTACT_US_FROM_HOME: 'HIDECONTACTUSFROMHOMESCREEN',
        GROUP_TEAM_MEMBERS: 'USETEAMMEMBERTEAMS',
        HIDE_OVERVIEW_TAB: 'HIDEOVERVIEWTAB',
        USE_SIMPLE_PROJECT_ENGAGEMENT: 'USESIMPLEPROJECTENGAGEMENT',
        TEAM_MEMBERS_ALPHABETICALLY: 'TEAMMEMBERSALPHABETICALLY',
        SHOW_PROFILE_EDIT: 'SHOWPROFILEEDIT'
    },
    ROUTER_MAPS: {
        GDN: 'GlobalDeliveryNetwork',
        SETTINGCOMPANYCONTENT: 'CustomCompanyContent',
        MACSVERSE: 'MACSverseCustomCompanyContent',
        IDEABOARD: 'IdeasTab',
        CONTACTUS: 'ContactUs',
        NEWSFORYOU: 'News',
        AGENDA: 'Agenda',
        MEETYOURTEAM: 'MeetYourTeam',
        FILES: 'Files',
        SOLUTIONSFORYOU: 'Solutions',
        PROJECTANDINITIATIVES: 'Projects',
        CLIENTS: 'Clients',
        QUIZ: 'QuizIndex',
        HOWWEAREPERFORMING: 'Performance',
        WHATWEDOFORYOU: 'WhatWeDoForYou',
    },
    HOME_ICONS: {
        WHATWEDOFORYOU: 'home_icon_what_we_do_for_you.svg',
        IDEABOARD: 'home_icon_idea_board.svg',
        MEETYOURTEAM: 'home_icon_meet_your_team.svg',
        NEWSFORYOU: 'home_icon_news_for_you.svg',
        CONTACTUS: 'home_icon_contact_us.svg',
        FILES: 'home_icon_files.svg',
        SOLUTIONSFORYOU: 'home_icon_solution_portfolio.svg',
        AGENDA:'home_icon_agenda.svg',
        PROJECTANDINITIATIVES: 'home_icon_projects.svg',
        CLIENTS: 'home_icon_clients.svg',
        QUIZ: 'home_icon_quiz.svg',
        HOWWEAREPERFORMING: 'home_icon_performance.svg',
        SETTINGCOMPANYCONTENT: 'home_icon_custom_content.svg',
        GDN: 'home_icon_gdn.svg',
        WEBCONTENT: 'home_icon_gdn.svg',
    },
    PERFORMANCE_ICONS: {
      PROJECTMANAGEMENT: 'performance_project_management.svg',
      RATING: 'performance_rating.svg',
      WORKINGTOGETHER: 'performance_working_together.svg',
      CHECKINGDONEOK: 'performance_checking_done_ok.svg',
      QUALITYAWARD: 'performance_quality_award.svg',
    },
    CURRENT_ENABLED_SECTIONS_TO_BOOKMARK: [
      'CLIENTS',
      'SETTINGCOMPANYCONTENT',
      'NEWSFORYOU',
      'MEETYOURTEAM',
      'SOLUTIONSFORYOU',
    ],
    CURRENT_ENABLED_SECTIONS: [
      'GDN',
      'CLIENTS',
      'SETTINGCOMPANYCONTENT',
      'IDEABOARD',
      'CONTACTUS',
      'NEWSFORYOU',
      'AGENDA',
      'MEETYOURTEAM',
      'FILES',
      'SOLUTIONSFORYOU',
      'PROJECTANDINITIATIVES',
      'QUIZ',
      'HOWWEAREPERFORMING',
      'WEBCONTENT',
      'WHATWEDOFORYOU',
    ],
}
